import { render } from "./list_new.vue?vue&type=template&id=3d60eaf4"
import script from "./list_new.js?vue&type=script&lang=js&external"
export * from "./list_new.js?vue&type=script&lang=js&external"

import "./list_new.vue?vue&type=style&index=0&id=3d60eaf4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__